import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class SupportMessage extends AbstractModel {
  @autoserialize
  personId: number;

  @autoserialize
  platform: string;

  @autoserialize
  applicationVersionNumber: string;

  @autoserialize
  applicationName: string;

  @autoserialize
  replyToEmailAddress: string;

  @autoserialize
  message: string;
}
